/**
 * Playground-only DUPLICATE_SESSION guidance.
 *
 * The room server rejects a second join for an identity already seated in the
 * room. In the playground the cause is almost always two clients on the single
 * base identity (the coordinator's localStorage registry isn't shared across
 * browsers/profiles/automation contexts, so each claims slot 0). The server
 * message says WHAT happened; this hint says how to fix it, pointing at the
 * canonical testing patterns. Gated on the playground global so the real RUN
 * client (RemoteHost — never sets it) is unaffected, and deduped per page load
 * so reconnect retries don't spam the console.
 */

let logged = false

export function maybeLogPlaygroundDuplicateSessionHint(code: string | undefined): void {
  if (code !== 'DUPLICATE_SESSION' || logged) return
  if (typeof window === 'undefined') return
  const playground = (window as { __RUNDOT_GAME_PLAYGROUND__?: { enabled?: boolean } })
    .__RUNDOT_GAME_PLAYGROUND__
  if (!playground?.enabled) return
  logged = true
  console.warn(
    '[RUN:playground] DUPLICATE_SESSION: two clients joined with the SAME player identity. ' +
    'Every browser instance sharing one playground base identity (one Google account or one ' +
    'pk_ key) needs its own player. Canonical fixes (see "Test multiple players" in the ' +
    'playground docs):\n' +
    '  • Same browser: open players as tabs in one window — distinct players are assigned automatically.\n' +
    '  • Separate browsers/profiles/automation contexts: pin each one with a distinct value, ' +
    'e.g. ?rundotPlayer=player2 (any [a-zA-Z0-9_]{1,32} value, unique per instance).',
  )
}
